@if (article) {
<div class="__component" [class.--is-selected]="isSelected">
  <div class="__inner">
    @if (article.publicationDate && article.publicationDate.length > 12 && dateFormat !== 'ignore') {
    <div class="fw-bolder me-1">{{ article.publicationDate | date: dateFormat }}</div>
    }
    @if (article.publicationDate && dateFormat === 'ignore') {
    <div class="fw-bolder me-1">{{ article.publicationDate }}</div>
    }
    <p [class]="heading" data-test="list-item__title" [innerHTML]="splitTitle(article.title)"></p>
    @if (article.snippets) {
    <p [innerHTML]="article.snippets"></p>
    } @else {

    @if (showDescription && breakpointService.expandListing && article.description && article.description.length > 3) {
    <p class="m-0" [innerHTML]="removeDate(article.description)"></p>
    }

    }
    @if (showAttributes && breakpointService.expandListing && article.attributes) {
    <ul class="list-inline">
      @for (attributeName of attributeOrder; track attributeName) {

      @for (attribute of article.attributes[attributeName]; track attribute) {
      <ng-container class="list-inline">
        <li class="list-inline-item">
          <button type="button" [className]="attributeNameToColour(attributeName)" (click)="attributeClick($event, attributeName, attribute.value)">{{attribute.name}}</button>
        </li>
      </ng-container>
      }

      }
    </ul>
    }
  </div>
  <div class="corner"></div>
</div>
}